// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__37_Rt","inputDescription":"styles_inputDescription__2vZH1"};